import { useTranslation } from "react-multi-lang";
import { useDispatch, useSelector } from "react-redux";
import Action from "../redux/Action";

const SelectItemCategory = () => {
  const t = useTranslation();
  const dispatch = useDispatch();

  const formValue = useSelector((state) => state.reducer.formValue);
  const errors = useSelector((state) => state.reducer.errors);

  const getOptions = () => {
    return [
      { value: "ALL_PRODUCTS", label: "All Products" },
      { value: "GOLD_BAR", label: "Gold Bar" },
      { value: "JEWELRY", label: "Jewelry" },
    ];
  };

  const options = getOptions();

  return (
    <>
      <p className="font-plus-jakarta-sans font-normal text-sm leading-none tracking-normal text-[#4E5554] mt-3 mb-2">
        {t("management.item_category")}
      </p>
      <select
        className={`text-sm border ${errors.productCategory ? "border-red-500" : "border-gray-primary"} rounded-xl w-full bg-white font-medium `}
        name="productCategory"
        value={formValue.productCategory}
        onChange={(e) => {
          const name = e.target.name;
          const value = e.target.value;
          Action.handleFormChange(dispatch, { name, value, formValue });
        }}
      >
        <option value="" disabled>
          {t("management.select_target")}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </>
  );
};

export default SelectItemCategory;
